import { render, staticRenderFns } from "./grassshow.vue?vue&type=template&id=16c9f196&scoped=true"
import script from "./grassshow.vue?vue&type=script&lang=ts"
export * from "./grassshow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c9f196",
  null
  
)

export default component.exports